package link.erpango.quip.data.firebase.analytics

import link.erpango.quip.data.firebase.IFirebaseClient

class FirebaseAnalytics(
    private val client: IFirebaseClient
): IFirebaseAnalytics {
    override fun logEvent(event: String, param: String) {
        client.logAnalyticsEvent(event, param)
    }
}